<template>
  <v-card 
    flat
    class="rounded-lg ma-1"
  >
    <v-card-title class="d-flex align-center">
      Aprovações de Requisições
    </v-card-title>

    <v-card-text>
      <v-tabs
        v-model="tab"
        align-tabs="center"
        color="red-darken-4"
      >
        <v-tab :value="1">Aguardando Aprovação</v-tab>
      </v-tabs>

      <div class="d-flex justify-end py-4 px-2 ga-2">
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          density="compact"
          label="Procurar"
          prepend-inner-icon="mdi-magnify"
          variant="solo-filled"
          flat
          hide-details
          single-line
        ></v-text-field>
      </div>
      
      <v-window v-model="tab">
        <v-window-item :value="1">
          <v-data-table 
            v-model:search="search" 
            :items="waitingApprovalRequests"
            :headers="headers"
          >
            <template v-slot:[`item.priority`]="{ item }">
              <v-chip :color="priorityColor(item)">
                {{ priorityLabel(item) }}
              </v-chip>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-btn
                class="text-none font-weight-regular"
                icon="mdi-eye"
                variant="plain"
                size="small"
                @click="viewRequest(item)"
              ></v-btn>
            </template>
          </v-data-table>
        </v-window-item>
      </v-window>
    </v-card-text>

    <RequestDetailsDialog 
      v-model="detailsDialog"
      :request="selectedRequest"
      @snackbar="snackbarHandler"
      @close="detailsDialog = false"
    />
    
    <v-snackbar
      v-model="snackbar.active"
      :timeout="4000"
      :color="snackbar.color"
      elevation="24"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </v-card>
</template>

<script>
import RequestDetailsDialog from '@/components/Request/RequestDetailsDialog.vue';
import { mapGetters } from 'vuex';
import { PRIORITY_TYPES } from '@/helpers/constants/app.constants';
export default {
  name: 'ApprovalContent',

  components: { 
    RequestDetailsDialog,
  },
  
  data: () => ({
    tab: 1,
    search: '',
    detailsDialog: false,
    selectedRequest: null,
    snackbar: {
      text: '',
      color: '',
      active: false
    }
  }),

  computed: {
    ...mapGetters('request', ['waitingApprovalRequests']),

    headers() {
      return [
        { title: 'Código', key: 'code' },
        { title: 'Setor', key: 'sector' },
        { title: 'Descrição', key: 'description' },
        { title: 'Requisitado', key: 'requestDate' },
        { title: 'Prioridade', key: 'priority' },
        { title: 'Ações', key: 'action', sortable: false }
      ]
    },
  },

  methods: {
    priorityLabel(item) {
      return PRIORITY_TYPES[item.priority].label;
    },

    priorityColor(item) {
      return PRIORITY_TYPES[item.priority].color;
    },

    viewRequest(item) {
      console.log(item);
      this.selectedRequest = item;
      this.detailsDialog = true;
    },
    
    snackbarHandler({color, text}) {
      this.snackbar.color = color;
      this.snackbar.text = text;
      this.snackbar.active = true;
    }
  }
}
</script> 